// Sport Energy Guide — Regel-modul (Fase 5.8.0)
//
// FASE 5.8.0 (12. jun 2026): getQuantityEstimate runder gels og barer
// til hele enheder pr. time (gulv på 1) — ingen tager 1,5 gel.
// Pulver/chews doseres fortsat i halve portioner.
//
// FASE 5.2.0 (12. jun 2026): selectTopMatches — de tre rangerede
// match til resultatsiden. Pool-opbygning og rangering udtrukket i
// resolveCuratedPool/rankKlassikerPool, delt med selectCurated så
// kort og kit aldrig kan rangere forskelligt.
//
// FASE 2.14.1 (10. jun 2026): Natrium beregnes med profil-typisk
// midt-koncentration på væskebåndet — smallere, handlingsbart mål.
//
// FASE 2.14.0 (10. jun 2026): getFuelingPlan — time-for-time-plan.
// Interval = det 5-min-multiplum hvis effektive g/t er tættest på
// målets midtpunkt (inden for båndet hvis muligt). Pre-start-slot
// ved race/ultra. Drink-mix får blandingsinstruktion, ikke slots.
//
// FASE 2.13.0 (10. jun 2026): getHydrationTarget — væske- og
// natrium-mål pr. time. Estimat fra profil/intensitet eller præcist
// fra atletens målte svedtab (state.sweatRateMl).
//
// FASE 2.12.0 (9. jun 2026): fast-mad-scoringen kører på
// getProductFormat (variant-metafelt først, titel kun som fallback)
// i stedet for direkte titel-regex — omdøbte produkter knækkede
// tidligere scoringen lydløst. Pointværdier bevaret; ét produkt
// rammer nu præcis ét format (før kunne 'solid' stacke).
//
// FASE 2.10.0 (9. jun 2026): Præcis varighed.
// - bucketFromMinutes(min): afleder bucket af præcis tid.
// - getQuantityEstimate/getKitQuantity: state.durationMin (minutter)
//   slår bucket-intervallet i totaler og kit-antal. g/t-målet er
//   fortsat bucket-baseret — de 8 regler interpoleres ikke.
//
// FASE 2.8.0 (9. jun 2026): getKitQuantity — ét konkret kit-antal
// (midtpunkts-beregning) til "Pak til passet"-kortet i runtime.
//
// FASE 2.7.0 (9. jun 2026): Mængdeberegning.
// - getCarbTarget eksponerer nu numeriske gMin/gMax ved siden af
//   display-strengen, så beregninger ikke skal parse tekst.
// - NY: getQuantityEstimate(p, state) oversætter kulhydrat-målet til
//   konkrete antal af det enkelte produkt (pr. time + til hele passet).
//   Ren funktion uden DOM — kan genbruges af race-kit-byggeren senere.
// - Modul-load-log er gated bag window.SEG_DEBUG (jf. Fase 2.6.0).
//
// Dette modul indeholder den faglige logik der driver guidens anbefalinger.
// Det er bevidst designet uden DOM-afhængigheder og uden global state-
// mutation, så samme regler kan genbruges af:
//   - Den nuværende guide (sport-energy-guide.js)
//   - En kommende race-kit-bygger
//   - En kommende træningsberegner
//
// FASE 2.4.2 (30. apr 2026): Sport + intensitet differentiering.
// Tre sportsgrene giver nu reelt forskellige anbefalinger ved samme
// profil/duration/intensitet — ikke kun forskellige why-tekster.
//
// Filosofi: intensitet-først, sport-modifikator. En interval-løber og en
// ultra-løber er begge "løb", men har modsatte fueling-behov. Sport bliver
// derfor en modifikator på intensitets-baseret logik.
//
// Tre principper i scoreProduct (energi-under-grenen):
//   1. Race/hård intensitet: gels og lav-osmolaritet drinks vinder.
//      Bars og chews får penalty, hårdest for løb hvor mavebelastningen
//      er størst (+18 til løb-gel, -18 til løb-bar; +8/-8 for cykling).
//   2. Let intensitet: alle formater åbner. Cykling får drink-mix-bonus
//      (+12) pga. flaske-tilgængelighed.
//   3. Ultra-undtagelsen (over-4t + let): bars/chews/waffles får +14 bonus
//      (variation essentiel), koncentrater åbner (+10 ved Ekstra stor).
//
// Plus: lille certificerings-bonus (+5) ved race-intensitet for produkter
// med Informed Sport eller Cologne List® — konkurrence-atleter foretrækker
// disse.
//
// Den gamle cykling-bonus (+3 til drink mix) er erstattet af denne mere
// differentierede logik.
//
// FASE 2.4.1 (30. apr 2026): Profil- og sport-konsolidering.
// Færre, skarpere valg i UI'en med stærkere differentiering i scoring.
// - Mave-options reduceret fra 4 til 2 (solid/følsom). Mave-meget-følsom og
//   mave-ny smeltes ind i mave-følsom — i praksis fik de næsten samme
//   produkt-anbefaling alligevel. Scoring konsolideret med højere
//   Maurten-bias (+18) der dækker hele følsom-spektret.
// - Svedtab-options reduceret fra 3 til 2 (normal/meget). Svedtab-salt
//   smeltes ind i svedtab-højt — saltrande nævnes nu som signal i
//   beskrivelsen, ikke som separat valg. Scoring konsolideret med højere
//   natrium-bias (+12) og PH-1500-bias (+15).
// - Sport-options reduceret fra 4 til 3. HYROX fjernet — for få atleter
//   til at retfærdiggøre en plads i guiden. Kan tilføjes igen senere hvis
//   data viser segmentet vokser.
// - getAthleteLevel: mave-følsom giver fortsat "experienced"-niveau (svagere
//   signal end mave-meget-følsom, men beholder den nuancerede why-tekst).
// - Cykling-bonus i scoreProduct beholdes uændret — Trin 2 (sport-
//   differentiering med intensitet-først logik) bygges separat senere.
//
// FASE 2.2.2 (29. apr 2026): Strammere hydrerings-filter.
// Tidligere kunne energi-pulvere (60g carbs+) glide ind i hydrerings-resultatet
// fordi de havde elektrolytter og "Under træning"-tag. Det var fagligt skævt
// — atleter der vælger hydrering ønsker rene hydrerings-produkter, ikke
// energi-mix der tilfældigvis har elektrolytter.
//
// Ny regel for hydrerings-grenen:
//   ACCEPTÉR: variant === 'Tabletter' (kapsler/tabletter er pr. definition rene hydrerings-produkter)
//   ACCEPTÉR: variant === 'Pulver med energi' med subCategory 'træningshydrering' (carbPerPortion < 25g) eller 'daglig-hydrering' (< 5g)
//   ACCEPTÉR: variant === 'Energipulver' / 'Pulver tilskud' / 'Flydende tilskud' MEN kun hvis carbPerPortion < 25g
//   ACCEPTÉR: legacy fallback (filter.formal indeholder hydrerings-tag) MEN kun hvis variant ikke peger på energi-format
//   AFVIS: alle gel/bar/chew/waffle/solid-formater
//   AFVIS: produkter med carbPerPortion >= 25g uanset elektrolyt-indhold
//
// FASE 2.2.1 (uændret i runtime): "Ingen ekstra energi"-mode er implementeret
// i sport-energy-guide.js. Reglerne her ændres ikke for det.
//
// FASE 2 (uændret): Ved init klassificerer guiden alle produkter via FINAL2-
// regelsættet:
//   - REGEL 1: Eksklusion via nutrition.variant (Flasker — IKKE Crews/chews) — i Liquid-snippet
//   - REGEL 2: Hovedformål via nutrition.variant → mainPurpose
//   - REGEL 3: Tidspunkt via sport.anvendelse (direkte i feltet)
//   - REGEL 4: Subkategorisering af "Pulver med energi" via kulhydrat-tærskel
//   - REGEL 9: Specielle flags (race-egnet, lang-træning, lavt-sukker)
//   - REGEL 10: Sportstilskud subkategorisering via brand + produktnavn
//   - REGEL 11: Manuel override (filter.formal vinder over automatik)
//
// REGEL 5-8 (niveau-tærskler per type) er udskudt til fase 3 fordi de
// kræver scoring-kode-ændring.
//
// Maurten Additions og kombinations-anbefalinger er udskudt til race-kit-
// byggeren da de kræver multi-produkt-output.
//
// Eksponeres som window.SportEnergyRules.
//
// API-kontrakt:
//   Alle funktioner der afhænger af atletens valg tager `state` som parameter.
//   `state` er et objekt med disse felter (alle valgfri):
//     {
//       formal:    'energi-under' | 'hydrering' | 'restitution' | 'sportstilskud',
//       sport:     'løb' | 'cykling' | 'triathlon',
//       duration:  'under-1t' | '1-2t' | '2-4t' | 'over-4t',
//       intensity: 'let' | 'moderat' | 'race',
//       profile:   'mave-solid' | 'mave-følsom' | 'svedtab-normal' | 'svedtab-højt' |
//                  'restitution-hurtig' | 'restitution-protein' | 'restitution-vegansk' |
//                  'multi' (for sportstilskud),
//       modifiers: ['med-koffein', 'fast-mad', 'søvn-restitution', ...]
//     }
//
//   Alle funktioner returnerer nye værdier — de muterer ikke state eller produkter.

(function() {
  'use strict';

  // ══════════════════════════════════════════════════
  //  KONSTANTER
  // ══════════════════════════════════════════════════

  // Mapping fra step 1-formål til de filter.formal-tags der definerer
  // produkter i den kategori. Bruges af matchProducts.
  var FORMAAL_TARGETS = {
    'energi-under':  ['Alm. træning', 'Lang træning', 'Tempo', 'Ydelse & Udholdenhed', 'Lavt sukkerindhold'],
    'hydrering':     ['Alm. træning'], // hydrering bruger sin egen filter-logik baseret på elektrolyt
    'restitution':   ['Efter normal træning', 'Efter hård belastning'],
    'sportstilskud': ['Søvn & Restitution', 'Immunforsvar', 'Led & Skadesforebyggelse', 'Fokus & Mental Skarphed', 'Ydelse & Udholdenhed']
  };

  var SUPPLEMENT_CATEGORY_LABELS = {
    'søvn-restitution':   'Til søvn & restitution',
    'skadesforebyggelse': 'Til skadesforebyggelse',
    'immunforsvar':       'Til immunforsvar',
    'performance':        'Til performance',
    'mental-fokus':       'Til mental fokus'
  };

  var SUPPLEMENT_CATEGORY_FORMAL = {
    'søvn-restitution':   'Søvn & Restitution',
    'skadesforebyggelse': 'Led & Skadesforebyggelse',
    'immunforsvar':       'Immunforsvar',
    'performance':        'Ydelse & Udholdenhed',
    'mental-fokus':       'Fokus & Mental Skarphed'
  };

  var HANDLE_PRIORITY = {
    'søvn-restitution':   ['magnesium', 'sleep'],
    'immunforsvar':       ['immune', 'immun', 'vitamin-c', 'zinc', 'zink'],
    'skadesforebyggelse': ['collagen', 'kollagen', 'omega', 'joint', 'motion-armour'],
    'performance':        ['creatine', 'kreatin', 'beet', 'nitrate', 'nitrat'],
    'mental-fokus':       ['focus', 'fokus', 'pre-workout', 'koffein-kapsler']
  };

  // FASE 2.2.2: Tærskel for hvad der tæller som "rent hydrerings-produkt".
  // Produkter med carbPerPortion under denne tærskel er i hydrerings-grenen
  // (træningshydrering / daglig hydrering). Over denne tærskel er de
  // energi-produkter — selv hvis de har elektrolytter indbygget.
  var HYDRATION_CARB_THRESHOLD = 25;

  // FASE 2.4.7: Øvre tærskel for "hybrid" hydration-med-energi-produkter.
  // Produkter med kulhydrat_hydration === "Med kulhydrat" tag er eksplicit
  // designet til hydration MED energi (fx Neversecond C30 = 30g, PFH Carb &
  // Electrolyte = 30g). De er hybrid-produkter, ikke fueling-produkter.
  // Tærsklen på 35g holder rene fueling-pulvere (40g+) ude af hydrerings-
  // grenen — de hører hjemme under "energi-under" formålet.
  var HYDRATION_CARB_THRESHOLD_HYBRID = 35;

  // FASE 2.2.2: Energi-formater der ALDRIG hører hjemme i hydrerings-grenen,
  // uanset elektrolyt-indhold eller hvornar-tagging.
  var ENERGY_ONLY_FORMATS = {
    'gel':    true,
    'bar':    true,
    'chew':   true,
    'waffle': true,
    'solid':  true
  };

  // ══════════════════════════════════════════════════
  //  CARB-TARGET (Roches 8 regler)
  // ══════════════════════════════════════════════════
  // ══════════════════════════════════════════════════
  //  FILTER STATUS (FASE 2.4.5)
  // ══════════════════════════════════════════════════
  // Holder seneste filter-status fra matchProductsV2.
  // Bruges af guide.js til at vælge mellem normal-render,
  // limited-state-besked, eller empty-state.
  //
  // status-værdier:
  //   'OK'           — alt fint, normalt antal produkter
  //   'LIMITED'      — 1-2 produkter passerede filter (vis besked)
  //   'EMPTY'        — 0 produkter passerede filter (vis empty state)
  //   'INCOMPATIBLE' — filter er logisk inkompatibelt med formål (vis empty state)
  var lastFilterStatus = {
    status: 'OK',
    appliedFilters: [],
    incompatibleFilter: null,
    incompatibleReason: null,
    matchedCount: 0,
    unfilteredCount: 0
  };

  // Inkompatibilitets-regler: hvilke filter+formål-kombinationer er logisk
  // umulige? Returnerer reason-streng eller null hvis ikke inkompatibel.
  function checkFilterIncompatibility(filterName, formal) {
    if (filterName === 'fast-mad') {
      if (formal === 'hydrering')   return 'Fast føde matcher ikke hydrering — vi viser kun drikke- og elektrolyt-produkter her.';
      if (formal === 'restitution') return 'Fast føde matcher ikke restitution — efter træning er det protein-pulver eller drikke der virker bedst.';
      if (formal === 'sportstilskud') return 'Fast føde matcher ikke sportstilskud — det er typisk kapsler eller pulvere.';
    }
    if (filterName === 'tabletter') {
      if (formal === 'energi-under') return 'Tabletter er sjældent fueling under træning — fueling sker via gels, drikke eller fast føde.';
      if (formal === 'restitution')  return 'Tabletter er ikke restitutions-produkter — efter træning bruges typisk pulver eller drikke.';
    }
    return null;
  }

  function getFilterStatus() {
    return lastFilterStatus;
  }

  function getCarbTarget(state) {
    if (!state) return null;
    var duration = state.duration, intensity = state.intensity;

    // FASE 2.7.0: gMin/gMax er numeriske spejl af display-strengen.
    // Bruges af getQuantityEstimate — hold dem altid synkrone med display.
    if (duration === 'under-1t' && intensity === 'let') return { display: 'Ingen ekstra energi', rule: 1 };
    if (duration === 'under-1t')                         return { display: '60g per time', rule: 5, gMin: 60, gMax: 60 };
    if (duration === '1-2t' && intensity === 'let')      return { display: '45–60g per time', rule: 2, gMin: 45, gMax: 60 };
    if (duration === '1-2t')                             return { display: '60–75g per time', rule: 6, gMin: 60, gMax: 75 };
    if (duration === '2-4t' && intensity === 'let')      return { display: '60–75g per time', rule: 3, gMin: 60, gMax: 75 };
    if (duration === '2-4t')                             return { display: '75–90g per time', rule: 6, gMin: 75, gMax: 90 };
    if (duration === 'over-4t' && intensity === 'let')   return { display: '75–90g per time', rule: 4, gMin: 75, gMax: 90 };
    if (duration === 'over-4t' && intensity === 'race')  return { display: '90–120g per time', rule: 8, gMin: 90, gMax: 120 };
    if (duration === 'over-4t')                          return { display: '75–90g per time', rule: 4, gMin: 75, gMax: 90 };
    return null;
  }

  function getRequiredRatios(state) {
    var target = getCarbTarget(state);
    if (!target || !target.display) return null;
    var matches = target.display.match(/(\d+)\s*g/g);
    if (!matches || matches.length === 0) return null;
    var lastMatch = matches[matches.length - 1];
    var upper = parseInt(lastMatch);
    if (isNaN(upper)) return null;
    if (upper >= 75) return ['Performance: 2:1', 'Max: 1:0.8'];
    return null;
  }

  // FASE 2.4.2: Ultra-let-undtagelse fra ratio-filter.
  // Ved over-4t + let intensitet (ultra-distance, lav puls) relaxes ratio-
  // kravet. Fagligt rigtigt: ved Z1/Z2 er oxidations-raten lavere, så kroppen
  // klarer sig fint med "Komfort"-ratio. Det er præcis pointen med produkter
  // som Tailwind, näak Ultra-serien og Maurten Solid — de er specifikt
  // designet til ultra-let-fueling og har Komfort-ratio fordi det er det
  // rigtige valg for den kontekst.
  //
  // Race-intensitet ved enhver varighed beholder fortsat ratio-kravet —
  // ved høj puls er Performance 2:1 eller Max 1:0.8 nødvendigt for at nå
  // 90+ g carbs/time.
  //
  // Returnerer false når ratio-filter skal være inaktivt.
  function shouldEnforceRatioFilter(state) {
    if (!state) return true;
    var isUltraLight = state.duration === 'over-4t' && state.intensity === 'let';
    if (isUltraLight) return false;
    return true;
  }

  // ══════════════════════════════════════════════════
  //  ATLET-NIVEAU
  // ══════════════════════════════════════════════════
  function getAthleteLevel(state) {
    if (!state) return 'intermediate';
    if (state.duration === 'over-4t')                                         return 'experienced';
    if (state.sport === 'triathlon' && state.duration === '2-4t' && state.intensity === 'race') return 'experienced';
    // FASE 2.4.1: mave-følsom giver fortsat experienced — den dækker nu også
    // det tidligere mave-meget-følsom-segment, og atleter der aktivt vælger
    // "følsom mave" har som regel tænkt over deres fueling-strategi.
    if (state.profile === 'mave-følsom')                                       return 'experienced';
    if (state.sport === 'cykling' && state.duration === '2-4t' && state.intensity === 'race') return 'experienced';

    if (state.duration === 'under-1t' && state.intensity === 'let')            return 'novice';
    if (state.duration === '1-2t' && state.intensity === 'let')                return 'novice';

    return 'intermediate';
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.13.0: HYDRERINGS-MÅL
  // ══════════════════════════════════════════════════
  // Væske- og natrium-mål pr. time. To niveauer:
  //   ESTIMAT  — profil + intensitet (tabeller nedenfor)
  //   PRÆCIST  — state.sweatRateMl (atletens målte svedtab):
  //              væske = 65–85 % af svedtabet. Fuld erstatning er
  //              ikke målet — et kontrolleret underskud er normalt
  //              og beskytter mod overdrikning.
  // Natrium: væskebånd × koncentrationsbånd. Salt-svedere
  //  (svedtab-højt — saltrande er signalet) får 800–1200 mg/L,
  //  normale 500–800 mg/L. Uden labtest er båndet det ærlige svar.
  // Ingen formål-gating her — det er kalderens ansvar, så
  //  noEnergyMode også kan bruge funktionen.
  var SWEAT_ESTIMATE_NORMAL = { 'let': [400, 600], 'moderat': [500, 800], 'race': [600, 900] };
  var SWEAT_ESTIMATE_SALTY  = { 'let': [600, 900], 'moderat': [800, 1100], 'race': [900, 1300] };

  function getHydrationTarget(state) {
    if (!state) return null;
    var salty = state.profile === 'svedtab-højt';
    var sr = (typeof state.sweatRateMl === 'number' && state.sweatRateMl > 0)
      ? state.sweatRateMl
      : null;

    var fluidMin, fluidMax;
    if (sr) {
      fluidMin = Math.round(sr * 0.65 / 50) * 50;
      fluidMax = Math.round(sr * 0.85 / 50) * 50;
    } else {
      var table = salty ? SWEAT_ESTIMATE_SALTY : SWEAT_ESTIMATE_NORMAL;
      var band = table[state.intensity] || table['let'];
      fluidMin = band[0];
      fluidMax = band[1];
    }

    // FASE 2.14.1: Midt-koncentration (normal 650, salt 1000 mg/L) på
    // væskebåndet. Før gangede vi min×min og max×max — to usikkerheder
    // kompounderet gav bånd ingen kan planlægge efter (700–1550 mg).
    // Væskebåndet bærer allerede usikkerheden; koncentrationen sættes
    // som profil-typisk midte.
    var conc = salty ? 1000 : 650;
    var sodiumMin = Math.round((fluidMin / 1000) * conc / 50) * 50;
    var sodiumMax = Math.round((fluidMax / 1000) * conc / 50) * 50;

    return {
      fluidMinMl: fluidMin,
      fluidMaxMl: fluidMax,
      sodiumMinMg: sodiumMin,
      sodiumMaxMg: sodiumMax,
      precise: !!sr,
      salty: salty
    };
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.7.0: MÆNGDEBEREGNING
  // ══════════════════════════════════════════════════
  // Oversætter kulhydrat-målet til konkrete antal af det enkelte produkt.
  // Det er det sidste regnestykke atleten ellers selv skulle lave:
  //   4 timers race × 75–90 g/t ÷ 25 g pr. gel = 12–15 gels.
  //
  // Returnerer null når beregningen ikke giver mening:
  //   - andet formål end energi-under (inkl. noEnergyMode, hvor
  //     runtime midlertidigt har sat formal til hydrering)
  //   - regel 1 (ingen ekstra energi)
  //   - ukendt eller manglende carbPerPortion
  //   - formater hvor antal ikke er en indkøbs-relevant enhed
  //
  // Ellers: {
  //   perHourMin, perHourMax  — antal pr. time, nærmeste halve
  //   totalMin, totalMax      — antal til hele passet. Begge null ved
  //                             under-1t (kun pr.-time giver mening);
  //                             totalMax er null ved over-4t (åben ende)
  //   unit                    — 'gel' | 'bar' | 'portion'
  // }
  //
  // Afrunding (FASE 5.8.0): gels og barer doseres i HELE enheder —
  // ingen tager 1,5 gel. Pr.-time rundes til nærmeste hele med gulv
  // på 1. Drikke/chews doseres fortsat i halve portioner. Totaler
  // rundes OP: at pakke for lidt er den reelle risiko.
  // FASE 2.10.0: Bucket af præcis tid. Grænser: et pas på præcis
  // 60 min hører til '1-2t' (rule 5/6-territorie), 120 min til '1-2t',
  // 240 min til '2-4t'. Returnerer null ved ugyldigt input.
  function bucketFromMinutes(min) {
    if (typeof min !== 'number' || !(min > 0)) return null;
    if (min < 60)   return 'under-1t';
    if (min <= 120) return '1-2t';
    if (min <= 240) return '2-4t';
    return 'over-4t';
  }

  var QTY_DURATION_HOURS = {
    'under-1t': { min: null, max: null },
    '1-2t':     { min: 1, max: 2 },
    '2-4t':     { min: 2, max: 4 },
    'over-4t':  { min: 4, max: null }
  };

  // Enheds-ord pr. format. 'portion' er altid korrekt (carbPerPortion
  // er pr. definition pr. portion) — gel og bar får deres eget ord
  // fordi det er sådan atleter taler om dem.
  var QTY_UNITS = {
    gel:    'gel',
    bar:    'bar',
    drink:  'portion',
    chew:   'portion',
    waffle: 'portion',
    solid:  'portion'
  };

  function getQuantityEstimate(p, state) {
    if (!state || state.formal !== 'energi-under') return null;
    var ct = getCarbTarget(state);
    if (!ct || ct.rule === 1 || !ct.gMin || !ct.gMax) return null;

    var carb = p ? p.carbPerPortion : null;
    if (!carb || carb <= 0) return null;

    var unit = QTY_UNITS[getProductFormat(p)];
    if (!unit) return null;

    function roundHalf(x) { return Math.round(x * 2) / 2; }

    // FASE 5.8.0: Gels og barer er hele enheder — man tager én hel
    // gel hver gang. Halve giver kun mening for ting der kan blandes
    // eller deles (pulver, chews).
    var wholeUnit = (unit === 'gel' || unit === 'bar');
    var perHourMin, perHourMax;
    if (wholeUnit) {
      perHourMin = Math.max(1, Math.round(ct.gMin / carb));
      perHourMax = Math.max(perHourMin, Math.round(ct.gMax / carb));
    } else {
      perHourMin = roundHalf(ct.gMin / carb);
      perHourMax = roundHalf(ct.gMax / carb);
      if (perHourMin < 0.5) perHourMin = 0.5;
      if (perHourMax < perHourMin) perHourMax = perHourMin;
    }

    // FASE 2.10.0: Præcis varighed slår bucket-intervallet i totaler
    // — også for under-1t og over-4t, hvor bucket-beregningen ellers
    // er åben. g/t-målet (gMin/gMax) er fortsat bucket-baseret.
    var totalMin = null;
    var totalMax = null;
    var preciseH = (typeof state.durationMin === 'number' && state.durationMin > 0)
      ? state.durationMin / 60
      : null;
    if (preciseH) {
      totalMin = Math.ceil((ct.gMin * preciseH) / carb);
      totalMax = Math.ceil((ct.gMax * preciseH) / carb);
    } else {
      var hours = QTY_DURATION_HOURS[state.duration] || { min: null, max: null };
      totalMin = hours.min ? Math.ceil((ct.gMin * hours.min) / carb) : null;
      totalMax = hours.max ? Math.ceil((ct.gMax * hours.max) / carb) : null;
    }

    return {
      perHourMin: perHourMin,
      perHourMax: perHourMax,
      totalMin: totalMin,
      totalMax: totalMax,
      unit: unit
    };
  }

  // FASE 2.8.0: Kit-antal til "Pak til passet"-kortet.
  // Kittet skal bruge ÉT konkret tal, ikke et interval. Vi regner med
  // midtpunktet af varigheds-bucket'en × midtpunktet af g/t-målet:
  //   2-4t race, gel 25 g: 3 t × 82,5 g/t ÷ 25 g = 9,9 → 10 gels.
  // over-4t regner med 4 timer — atleten justérer selv op til sin
  // distance (UI'en siger det eksplicit). under-1t pakker til én times
  // forbrug — lidt margin er den rigtige coach-anbefaling.
  //
  // Returnerer null på samme betingelser som getQuantityEstimate.
  // Ellers: { qty, hours, gMid, unit } — hours og gMid er beregnings-
  // grundlaget, så UI'en kan vise atleten regnestykket ærligt.
  var KIT_BASIS_HOURS = {
    'under-1t': 1,
    '1-2t':     1.5,
    '2-4t':     3,
    'over-4t':  4
  };

  function getKitQuantity(p, state) {
    var q = getQuantityEstimate(p, state);
    if (!q) return null;
    // FASE 2.10.0: Præcise timer slår bucket-basis.
    var hours = (typeof state.durationMin === 'number' && state.durationMin > 0)
      ? state.durationMin / 60
      : KIT_BASIS_HOURS[state.duration];
    if (!hours) return null;
    var ct = getCarbTarget(state);
    var gMid = (ct.gMin + ct.gMax) / 2;
    var qty = Math.max(1, Math.round((gMid * hours) / p.carbPerPortion));
    return { qty: qty, hours: hours, gMid: gMid, unit: q.unit };
  }

  // FASE 2.14.0: Race-plan — hvornår skal hver enhed ind?
  //
  // Interval-valg: det ideelle interval er carb/gMid × 60 min. Vi
  // vælger mellem de to omkringliggende 5-min-multipla og tager det
  // hvis effektive g/t (60×carb/interval) ligger tættest på gMid —
  // med præference for kandidater inden for [gMin..gMax]. Det holder
  // planen tro mod målet i stedet for blind afrunding.
  //
  // Pre-start-slot (min 0) ved race-intensitet eller pas over 4 timer
  // — kanonisk praksis, og den får leveret total tæt på målet.
  //
  // Koffein: slottet nærmest 2/3 af varigheden markeres, hvis atleten
  // har valgt med-koffein — sent nok til at bære sidste del, tidligt
  // nok til at nå at virke.
  //
  // Drink-mix planlægges ikke i slots — pulver doseres før start.
  // Returnerer { type:'drink', portions, perHour, ... } i stedet.
  function getFuelingPlan(p, state) {
    if (!state || state.formal !== 'energi-under') return null;
    var ct = getCarbTarget(state);
    if (!ct || ct.rule === 1 || !ct.gMin || !ct.gMax) return null;
    var carb = p ? p.carbPerPortion : null;
    if (!carb || carb <= 0) return null;
    var format = getProductFormat(p);
    var unit = QTY_UNITS[format];
    if (!unit) return null;
    var hours = (typeof state.durationMin === 'number' && state.durationMin > 0)
      ? state.durationMin / 60
      : KIT_BASIS_HOURS[state.duration];
    if (!hours) return null;

    var totalMin = Math.round(hours * 60);
    var gMid = (ct.gMin + ct.gMax) / 2;
    var openEnded = !(typeof state.durationMin === 'number' && state.durationMin > 0)
      && state.duration === 'over-4t';

    if (format === 'drink') {
      return {
        type: 'drink',
        portions: Math.max(1, Math.round((gMid * hours) / carb)),
        perHour: Math.round((gMid / carb) * 2) / 2,
        totalMin: totalMin,
        openEnded: openEnded
      };
    }

    var ideal = (carb / gMid) * 60;
    var lo = Math.max(5, Math.floor(ideal / 5) * 5);
    var hi = Math.ceil(ideal / 5) * 5;
    function gphAt(iv) { return (60 * carb) / iv; }
    function inBand(iv) { return gphAt(iv) >= ct.gMin && gphAt(iv) <= ct.gMax; }
    var intervalMin;
    if (lo === hi) intervalMin = lo;
    else if (inBand(lo) && !inBand(hi)) intervalMin = lo;
    else if (inBand(hi) && !inBand(lo)) intervalMin = hi;
    else intervalMin = (Math.abs(gphAt(lo) - gMid) <= Math.abs(gphAt(hi) - gMid)) ? lo : hi;
    if (intervalMin < 10) intervalMin = 10;
    if (intervalMin > 60) intervalMin = 60;

    var slots = [];
    // >= 240: over-4t-bucketens basis er præcis 4 timer og skal tælle som ultra.
    var preStart = (state.intensity === 'race' || totalMin >= 240);
    if (preStart) slots.push({ min: 0, n: 1 });
    var first = totalMin >= 240 ? 15 : 25;
    if (intervalMin < first) first = intervalMin;
    var t = first;
    var n = slots.length + 1;
    while (t <= totalMin - 5 && slots.length < 60) {
      slots.push({ min: t, n: n });
      t += intervalMin;
      n++;
    }
    if (!slots.length) slots.push({ min: Math.max(5, Math.min(first, totalMin - 5)), n: 1 });

    var caffeineIdx = -1;
    var mods = state.modifiers || [];
    if (mods.indexOf('med-koffein') >= 0 && slots.length > 1) {
      var targetT = totalMin * 2 / 3;
      var bestD = Infinity;
      for (var i = 0; i < slots.length; i++) {
        var d = Math.abs(slots[i].min - targetT);
        if (d < bestD) { bestD = d; caffeineIdx = i; }
      }
    }

    return {
      type: 'units',
      unit: unit,
      slots: slots,
      intervalMin: intervalMin,
      totalMin: totalMin,
      caffeineIdx: caffeineIdx,
      openEnded: openEnded
    };
  }

  // ══════════════════════════════════════════════════
  //  FORMAT-DETECTION
  // ══════════════════════════════════════════════════
  function getProductFormat(p) {
    var variant = p.variant || p.variant_raw;
    if (variant) {
      switch (variant) {
        case 'Gels':                return 'gel';
        case 'Energibar':           return 'bar';
        case 'Energipulver':        return 'drink';
        case 'Pulver med energi':   return 'drink';
        case 'Tabletter':           return 'tablet';
        case 'Recovery':            return 'drink';
        case 'Proteinbar':          return 'bar';
        case 'Protein Pulver':      return 'drink';
        case 'Crews':               return 'chew';
        case 'Flydende tilskud':    return 'drink';
        case 'Pulver tilskud':      return 'drink';
        case 'Kapsler':             return 'kapsel';
        case 'Kapsler & Tabletter': return 'kapsel';
      }
    }

    var t = (p.title || '').toLowerCase();
    if (t.indexOf('waffle') >= 0)                                    return 'waffle';
    if (t.indexOf('chew') >= 0)                                      return 'chew';
    if (t.indexOf('solid') >= 0)                                     return 'solid';
    if (/\bbar\b|energibar|fuel bar|crisp bar/.test(t))              return 'bar';
    if (t.indexOf('gel') >= 0)                                       return 'gel';
    if (t.indexOf('tablet') >= 0)                                    return 'tablet';
    if (t.indexOf('capsule') >= 0 || t.indexOf('kapsel') >= 0)       return 'kapsel';
    if (t.indexOf('drink mix') >= 0 || t.indexOf('drink-mix') >= 0)  return 'drink';
    if (t.indexOf('pulver') >= 0)                                    return 'drink';
    if (/\bdrink\b/.test(t) && /\bmix\b/.test(t))                    return 'drink';
    return 'gel';
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.2.2: HYDRATION QUALIFIER
  // ══════════════════════════════════════════════════
  // Strikt test: er dette produkt et rent hydrerings-produkt?
  //
  // Et produkt er et rent hydrerings-produkt hvis ALLE følgende holder:
  //   1. Format er ikke gel/bar/chew/waffle/solid (energi-formater)
  //   2. Hvis carbPerPortion er kendt, er den < 25g (HYDRATION_CARB_THRESHOLD)
  //   3. Det har enten:
  //      a) variant === 'Tabletter' (altid hydrerings)
  //      b) variant === 'Kapsler' med hydrerings-formal-tag, eller
  //      c) variant blandt drink-pulvere (Pulver med energi, Energipulver,
  //         Pulver tilskud, Flydende tilskud) MED elektrolyt-egenskaber
  //         eller hydrerings-formal-tag
  //      d) ingen variant men passende title-keyword + elektrolyt
  //
  // Returnerer true/false. Bruges som primær filter i hydrerings-grenen.
  function qualifiesAsHydration(p) {
    var format = getProductFormat(p);

    // Afvis: energi-formater
    if (ENERGY_ONLY_FORMATS[format]) return false;

    // Afvis: produkter med for høj kulhydrat-densitet.
    // FASE 2.4.7: Produkter eksplicit tagged "Med kulhydrat" via metafeltet
    // custom.filter_kulhydrat_hydration får en højere tærskel (35g) — det
    // er hybrid hydration-med-energi-produkter. Andre produkter holder
    // den strikte 25g-tærskel.
    if (p.carbPerPortion != null) {
      var isHybridHydration = (p.kulhydrat_hydration === 'Med kulhydrat');
      var threshold = isHybridHydration
        ? HYDRATION_CARB_THRESHOLD_HYBRID
        : HYDRATION_CARB_THRESHOLD;
      if (p.carbPerPortion >= threshold) return false;
    }

    var variant = p.variant || p.variant_raw;
    var hasElektrolyt = p.elektrolyt && p.elektrolyt !== 'Uden elektrolyt';
    var hasNatriumTag = p.natrium === '200 mg+';
    var formalTags = p.formal || [];
    var hasHydreringTag = formalTags.some(function(f) { return f && f.indexOf('Hydrering') === 0; });

    // Variant-baseret accept (mest pålidelige signal)
    if (variant === 'Tabletter') return true;

    // Pulver med energi: kun hydrerings-subkategorier
    if (variant === 'Pulver med energi') {
      return p.subCategory === 'træningshydrering' || p.subCategory === 'daglig-hydrering';
    }

    // Drink-pulvere med elektrolytter eller eksplicit hydrerings-tag
    if (variant === 'Energipulver' || variant === 'Pulver tilskud' || variant === 'Flydende tilskud') {
      return hasElektrolyt || hasNatriumTag || hasHydreringTag;
    }

    // Kapsler/Tabletter med hydrerings-tag (sjældent men muligt)
    if (variant === 'Kapsler' || variant === 'Kapsler & Tabletter') {
      return hasHydreringTag;
    }

    // Legacy fallback: produkt uden variant-data
    if (!variant) {
      var t = (p.title || '').toLowerCase();
      var titleSuggestsHydration = t.indexOf('drink mix') >= 0
                                || t.indexOf('hydration') >= 0
                                || t.indexOf('tablet') >= 0
                                || t.indexOf('hydro') >= 0
                                || t.indexOf('electrolyt') >= 0;
      if (titleSuggestsHydration && (hasElektrolyt || hasNatriumTag)) return true;
    }

    return false;
  }

  // ══════════════════════════════════════════════════
  //  PRODUKT-FILTER (matchProducts) — LEGACY
  // ══════════════════════════════════════════════════
  // Bevares for bagudkompatibilitet og for produkter der kommer ind uden
  // FINAL2-klassifikation. Er IKKE den primære match-funktion — det er
  // matchProductsV2 nedenfor (eksponeres som SR.matchProducts).
  function matchProducts(products, state) {
    if (!state || !state.formal) return [];
    var targetFormaal = FORMAAL_TARGETS[state.formal] || [];
    var mods = state.modifiers || [];
    var wantsKreatin     = mods.indexOf('med-kreatin') >= 0;
    var wantsPerformance = mods.indexOf('performance') >= 0;
    var allowYdelse = (state.formal === 'restitution' && wantsKreatin)
                   || (state.formal === 'sportstilskud' && wantsPerformance);

    var matched = products.filter(function(p) {
      if (state.formal === 'hydrering') {
        return qualifiesAsHydration(p);
      } else {
        if (!p.formal || p.formal.length === 0) return false;
        var effectiveTarget = allowYdelse ? targetFormaal.concat(['Ydelse & Udholdenhed']) : targetFormaal;
        var hasMatch = p.formal.some(function(f) { return effectiveTarget.indexOf(f) >= 0; });
        if (!hasMatch) return false;
      }
      return true;
    });

    var scored = matched.map(function(p) {
      return { p: p, score: scoreProduct(p, state) };
    });
    scored.sort(function(a, b) { return b.score - a.score; });

    return scored.map(function(s) { return s.p; });
  }

  // ══════════════════════════════════════════════════
  //  SCORING
  // ══════════════════════════════════════════════════
  function scoreProduct(p, state) {
    if (!state) state = {};
    var score = 0;
    var t = (p.title || '').toLowerCase();
    var h = (p.handle || '').toLowerCase();
    var mods = state.modifiers || [];

    // ───── ENERGI-UNDER: mavetolerance ─────
    // FASE 2.4.1: mave-meget-følsom og mave-ny er smeltet ind i mave-følsom.
    // Scoring konsolideret med højere Maurten-bias (+18) der dækker hele
    // følsom-spektret. Standard kulhydrat-niveau får mild bonus så
    // tidligere mave-ny-atleter stadig peges mod sikre valg.
    if (state.profile === 'mave-følsom') {
      if (p.brand === 'Maurten')                  score += 18;
      if (p.brand === 'Tailwind')                  score += 10;
      if (p.brand === 'Skratch Labs')              score += 6;
      if (p.kulhydrat === 'Standard (30–40 g)')    score += 5;
      if (p.kulhydrat === 'Ekstra stor (60 g+)')   score -= 3;
    }

    // ───── HYDRERING: svedtab/saltrande ─────
    // FASE 2.4.1: svedtab-salt er smeltet ind i svedtab-højt. Saltrande
    // nævnes nu som signal i UI-beskrivelsen, ikke som separat valg.
    //
    // FASE 2.4.3: Natrium-densitet pr. portion drives nu af faktisk mg-værdi
    // (sodiumPerPortion) i stedet for kategorisk "200 mg+"-flag og hardcoded
    // produktnavne. Det belønner produkter der leverer høj natrium-koncentration
    // i én praktisk portion (PH 1500 = 750mg/portion vs 5Electrolytes = 500mg
    // per 2 tabs). Bredspektrum-bonus er reduceret fra +15 til +8 — natrium
    // er den klart vigtigste elektrolyt under præstation, og bredspektrum bør
    // ikke overskygge densitet.
    if (state.profile === 'svedtab-højt') {
      // Natrium-densitet (gradueret skala — primær driver for hydrering ved højt svedtab)
      var sodMg = p.sodiumPerPortion;
      if (sodMg != null) {
        if (sodMg >= 700)        score += 18;  // PH 1500-tier — markedets højeste
        else if (sodMg >= 500)   score += 14;  // 5Electrolytes-tier (kun ved 2 tabs som anbefalet)
        else if (sodMg >= 300)   score += 10;  // Mellem-densitet
        else if (sodMg >= 200)   score += 6;   // Basal elektrolyt
      } else if (p.natrium === '200 mg+') {
        // Fallback hvis sodiumPerPortion ikke kunne parses fra metafield
        score += 8;
      }

      // Bredspektrum-bonus (reduceret fra +15) — anerkender at flere
      // mineraler er bedre, men ikke nok til at trumfe natrium-densitet.
      if (p.elektrolyt === 'Komplet elektrolyt (Alle mineraler)') score += 8;

      // Svedtab-tag (uforandret)
      if (p.svedtab === 'Højt')       score += 10;
      if (p.svedtab === 'Mellem')     score += 5;
    }

    // ───── RESTITUTION ─────
    if (state.profile === 'restitution-hurtig') {
      if (p.protein_type === 'Hydrolyseret (avanceret)')       score += 18;
      if (p.protein_type && p.protein_type.indexOf('Whey') >= 0) score += 10;
    }
    if (state.profile === 'restitution-protein') {
      if (p.protein === 'Højt') score += 18;
    }
    if (state.profile === 'restitution-vegansk') {
      if (p.kosttype && p.kosttype.indexOf('Vegansk') >= 0) score += 18;
      if (p.brand === 'Tailwind' || p.brand === 'näak')     score += 4;
    }

    // ───── ENERGI-UNDER modifiers ─────
    if (mods.indexOf('med-koffein') >= 0) {
      if (p.koffein === 'Med koffein') score += 12;
    }
    if (mods.indexOf('fast-mad') >= 0) {
      // FASE 2.12.0: Format-baseret i stedet for titel-regex.
      // getProductFormat læser variant-metafeltet først og falder
      // kun tilbage til titlen — omdøbninger knækker ikke scoringen.
      var fmFormat = getProductFormat(p);
      if (fmFormat === 'waffle')      score += 18;
      else if (fmFormat === 'solid')  score += 16;
      else if (fmFormat === 'bar')    score += 14;
      else if (fmFormat === 'chew')   score += 10;
    }

    if (state.formal === 'energi-under' && mods.indexOf('fast-mad') < 0) {
      var primaryFormat = getProductFormat(p);
      if (primaryFormat === 'drink' || primaryFormat === 'gel') {
        score += 5;
      }
    }

    // ───── HYDRERING modifiers ─────
    if (mods.indexOf('med-kulhydrat') >= 0) {
      var hasElectrolyte = (p.elektrolyt === 'Komplet elektrolyt (Alle mineraler)');
      var hasSomeCarb    = (p.kulhydrat === 'Lavt (0–19 g)' || p.kulhydrat === 'Mellem (20–39 g)');
      var isMidCarb      = (p.kulhydrat === 'Mellem (20–39 g)');
      var isTablet       = t.indexOf('tablet') >= 0 || h.indexOf('tablet') >= 0 || h.indexOf('capsule') >= 0;
      var isEveryday     = t.indexOf('everyday') >= 0;
      var isPulver       = (t.indexOf('drink mix') >= 0 || (t.indexOf('hydration') >= 0 && !isTablet) || t.indexOf('pulver') >= 0);
      if (hasElectrolyte && hasSomeCarb && isPulver && !isTablet && !isEveryday) {
        score += 14;
        if (isMidCarb) score += 4;
      }
    }
    if (mods.indexOf('tabletter') >= 0) {
      if (t.indexOf('tablet') >= 0) score += 14;
    }

    // ───── RESTITUTION modifiers ─────
    if (mods.indexOf('med-kreatin') >= 0) {
      if (h.indexOf('creatine') >= 0 || h.indexOf('kreatin') >= 0) score += 22;
    }

    // ───── SPORTSTILSKUD MULTI-SELECT ─────
    if (state.formal === 'sportstilskud' && state.profile === 'multi') {
      if (mods.indexOf('søvn-restitution') >= 0) {
        if (p.formal && p.formal.indexOf('Søvn & Restitution') >= 0) score += 20;
        if (h.indexOf('magnesium') >= 0) score += 15;
      }
      if (mods.indexOf('skadesforebyggelse') >= 0) {
        if (p.formal && p.formal.indexOf('Led & Skadesforebyggelse') >= 0) score += 20;
      }
      if (mods.indexOf('immunforsvar') >= 0) {
        if (p.formal && p.formal.indexOf('Immunforsvar') >= 0) score += 20;
      }
      if (mods.indexOf('performance') >= 0) {
        if (h.indexOf('creatine') >= 0 || h.indexOf('kreatin') >= 0)        score += 18;
        if (p.brand === 'Beet It Sport')                                    score += 18;
        if (p.formal && p.formal.indexOf('Ydelse & Udholdenhed') >= 0)      score += 10;
      }
      if (mods.indexOf('mental-fokus') >= 0) {
        if (p.formal && p.formal.indexOf('Fokus & Mental Skarphed') >= 0) score += 20;
      }
    }

    // Carb level match for energi
    if (state.formal === 'energi-under' && state.duration) {
      if ((state.duration === '2-4t' || state.duration === 'over-4t') && state.intensity !== 'let') {
        if (p.kulhydrat === 'Stor (41–59 g)')      score += 8;
        if (p.kulhydrat === 'Ekstra stor (60 g+)') score += 7;
        if (p.kulhydrat === 'Standard (30–40 g)')  score += 5;
      }
      if (state.duration === 'under-1t' || state.duration === '1-2t') {
        if (p.kulhydrat === 'Standard (30–40 g)')  score += 8;
        if (p.kulhydrat === 'Let (0–29 g)')        score += 5;
      }
      if (state.duration === 'over-4t' && state.intensity === 'let') {
        if (p.kulhydrat === 'Stor (41–59 g)')      score += 8;
        if (p.kulhydrat === 'Standard (30–40 g)')  score += 5;
      }
    }

    // ───── FASE 2.4.2: SPORT + INTENSITET DIFFERENTIERING ─────
    // Intensitet-først, sport-modifikator. En interval-løber og en ultra-løber
    // er begge "løb", men har modsatte fueling-behov. Sport bliver derfor en
    // modifikator på intensitets-baseret logik, ikke det dominerende signal.
    //
    // Tre principper:
    //   1. Race/hård intensitet: gels og lav-osmolaritet drinks vinder.
    //      Bars og chews får penalty, hårdest for løb hvor mavebelastningen
    //      er størst.
    //   2. Let intensitet: alle formater åbner. Cykling får drink-mix-bonus
    //      pga. flaske-tilgængelighed.
    //   3. Ultra-undtagelsen: over-4t + let betyder atleten typisk bruger
    //      softflasks med koncentrater eller fast mad. Bar/chew/koncentrat-
    //      bonus åbner her, selv for løb.
    //
    // Den gamle cykling-bonus (+3 til drink mix) er erstattet af denne
    // mere differentierede logik.
    if (state.formal === 'energi-under' && state.intensity && state.sport) {
      var format = getProductFormat(p);
      var flags = p.specialFlags || [];
      var isRaceOrHard = (state.intensity === 'race' || state.intensity === 'moderat');
      var isLight      = (state.intensity === 'let');
      var isUltra      = (state.duration === 'over-4t');
      var isUltraLight = (isUltra && isLight);

      // ─── Race/hård intensitet ─────────────────────────────
      if (isRaceOrHard) {
        // Race-egnet flag (allerede sat ved REGEL 9: koffein 50mg+ eller carb 35g+)
        if (flags.indexOf('race-egnet') >= 0) score += 12;

        // Format-bias: gels og drinks dominerer, bars/chews ned
        if (format === 'gel') {
          if (state.sport === 'løb')                              score += 18;
          else if (state.sport === 'cykling')                     score += 8;
          else if (state.sport === 'triathlon')                   score += 12;
        }
        if (format === 'drink') {
          if (state.sport === 'cykling')                          score += 12;
          else if (state.sport === 'triathlon')                   score += 8;
          else if (state.sport === 'løb')                         score += 4;
        }
        if (format === 'bar' || format === 'waffle' || format === 'solid') {
          if (state.sport === 'løb')                              score -= 18;
          else if (state.sport === 'cykling')                     score -= 8;
          else if (state.sport === 'triathlon')                   score -= 12;
        }
        if (format === 'chew') {
          if (state.sport === 'løb')                              score -= 12;
          else if (state.sport === 'cykling')                     score -= 4;
          else if (state.sport === 'triathlon')                   score -= 6;
        }

        // Maurten hydrogel-bias for løb (mavebelastning er størst der)
        if (state.sport === 'løb' && p.brand === 'Maurten')       score += 8;
      }

      // ─── Let intensitet (uden ultra) ──────────────────────
      if (isLight && !isUltraLight) {
        // FASE 2.4.3: Sport-differentieret format-bias.
        // Løbere bærer produktet på sig og tygger på farten — gels og drinks
        // er praktiske primær-fueling. Chews og bars er sværere at håndtere
        // mens man løber, selv på let intensitet. Cykling og triathlon
        // beholder uforandret logik (alle formater åbner).
        if (state.sport === 'løb') {
          if (format === 'gel')                                              score += 10;
          if (format === 'drink')                                            score += 8;
          if (format === 'bar' || format === 'waffle' || format === 'solid') score += 2;
          // chew: ingen bonus — naturligt lavere ranking end gels/drinks
        } else {
          // Cykling og triathlon: alle formater åbner, ingen penalty
          if (format === 'bar' || format === 'waffle' || format === 'solid') score += 8;
          if (format === 'chew')                                              score += 8;
        }

        // Cykling: drink-mix-bonus pga. flaske-tilgængelighed (uforandret)
        if (state.sport === 'cykling' && format === 'drink')               score += 12;
      }

      // ─── Ultra-undtagelsen (over-4t + let) ────────────────
      if (isUltraLight) {
        // Bars/chews/waffles får stor bonus — variation er essentiel
        if (format === 'bar' || format === 'waffle' || format === 'solid') score += 14;
        if (format === 'chew')                                              score += 12;

        // Koncentrater åbner — atleten bruger softflasks/veste
        if (format === 'drink' && p.kulhydrat === 'Ekstra stor (60 g+)')   score += 10;
        if (format === 'drink' && p.kulhydrat === 'Stor (41–59 g)')        score += 8;

        // Lang-træning flag (allerede sat ved REGEL 9: carb 40g+)
        if (flags.indexOf('lang-træning') >= 0)                            score += 8;
      }

      // ─── Race-day certificering bonus (alle intensiteter ved race) ─
      // Bemærk: filter.testet_til_sport er en certificering ('Informed Sport'
      // eller 'Cologne List®'), ikke en sport-tagging. Konkurrence-atleter
      // foretrækker certificerede produkter, så vi giver lille generel bonus
      // ved race-intensitet. Bonus er bevidst lille (+5) så det fungerer som
      // tiebreaker mellem ellers ens produkter.
      if (state.intensity === 'race') {
        var testet = p.testet_til_sport || (p.filter && p.filter.testet_til_sport);
        if (Array.isArray(testet) && testet.length > 0)                    score += 5;
        else if (typeof testet === 'string' && testet.length > 0)          score += 5;
      }
    }

    if (state.formal === 'hydrering') {
      if ((state.duration === '2-4t' || state.duration === 'over-4t') && p.svedtab === 'Højt') score += 6;
      if (state.intensity === 'race' && p.natrium === '200 mg+') score += 5;
    }

    if (state.formal === 'energi-under' && shouldEnforceRatioFilter(state)) {
      var requiredRatios = getRequiredRatios(state);
      if (requiredRatios && p.kulhydratforhold && requiredRatios.indexOf(p.kulhydratforhold) < 0) {
        score -= 30;
      }
    }

    return score;
  }

  // ══════════════════════════════════════════════════
  //  GROUP-BY-HVORNAR
  // ══════════════════════════════════════════════════
  function groupByHvornar(products) {
    var groups = { 'for': [], under: [], efter: [], daglig: [] };
    products.forEach(function(p) {
      if (!p.hvornar || p.hvornar.length === 0) {
        groups.under.push(p);
        return;
      }
      if (p.hvornar.indexOf('Før træning') >= 0)     groups['for'].push(p);
      if (p.hvornar.indexOf('Under træning') >= 0)   groups.under.push(p);
      if (p.hvornar.indexOf('Efter træning') >= 0)   groups.efter.push(p);
      if (p.hvornar.indexOf('Til daglig brug') >= 0) groups.daglig.push(p);
    });
    return groups;
  }

  // ══════════════════════════════════════════════════
  //  TOP-POOL ROTATION
  // ══════════════════════════════════════════════════
  var TOP_POOL_TOLERANCE = 0.15;
  var TOP_POOL_MAX_SIZE  = 3;

  function hashStateForSession(state) {
    if (!state) return 'empty';
    var parts = [
      state.formal     || '-',
      state.sport      || '-',
      state.duration   || '-',
      state.intensity  || '-',
      state.profile    || '-',
      (state.modifiers || []).slice().sort().join(',') || '-'
    ];
    return parts.join('|');
  }

  function getSessionCachedKlassiker(state) {
    try {
      if (typeof sessionStorage === 'undefined') return null;
      var key = 'seg_klassiker_' + hashStateForSession(state);
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setSessionCachedKlassiker(state, handle) {
    try {
      if (typeof sessionStorage === 'undefined') return;
      var key = 'seg_klassiker_' + hashStateForSession(state);
      sessionStorage.setItem(key, handle);
    } catch (e) {
      /* ignore */
    }
  }

  function pickKlassikerFromTopPool(sortedPool, scores, state) {
    if (!sortedPool || sortedPool.length === 0) return null;
    if (sortedPool.length === 1) return sortedPool[0];

    var topScore = scores[0];
    if (topScore == null) return sortedPool[0];

    var threshold;
    if (topScore > 0) {
      threshold = topScore * (1 - TOP_POOL_TOLERANCE);
    } else {
      return sortedPool[0];
    }

    var topPool = [];
    for (var i = 0; i < sortedPool.length && topPool.length < TOP_POOL_MAX_SIZE; i++) {
      if (scores[i] >= threshold) {
        topPool.push(sortedPool[i]);
      } else {
        break;
      }
    }

    if (topPool.length <= 1) return sortedPool[0];

    var cachedHandle = getSessionCachedKlassiker(state);
    if (cachedHandle) {
      for (var c = 0; c < topPool.length; c++) {
        if (topPool[c].handle === cachedHandle) return topPool[c];
      }
    }

    var pick = topPool[Math.floor(Math.random() * topPool.length)];
    setSessionCachedKlassiker(state, pick.handle);
    return pick;
  }

  // ══════════════════════════════════════════════════
  //  CURATED SELECTION
  // ══════════════════════════════════════════════════
  // ── FASE 5.2.0: Fælles pool-opbygning ─────────────────────────
  // selectTopMatches (de tre rangerede match på resultatsiden) og
  // selectCurated (kit-addon + specialist/supplement-folden) skal se
  // PRÆCIS samme pool og samme rangering — ellers drifter kortene og
  // kittet fra hinanden. Derfor lever opbygningen ét sted.
  function resolveCuratedPool(products, groups, state) {
    if (!state) state = {};
    if (!groups) groups = {};
    var pool = [];
    if (state.formal === 'energi-under' || state.formal === 'hydrering') {
      pool = groups.under || [];
    } else if (state.formal === 'restitution') {
      pool = groups.efter || [];
    } else {
      pool = (groups.daglig && groups.daglig.length > 0)
        ? groups.daglig
        : (groups.efter || []);
    }
    if (pool.length === 0) pool = products || [];
    return pool.filter(function(p) { return !p.isMaurtenAddition; });
  }

  // Rangerer poolen som Klassikeren altid er blevet valgt: carb-ratio-
  // filter, derefter negativ-defaults (fast mad og koffein udelukkes
  // når atleten ikke selv har valgt dem), derefter score-sortering.
  function rankKlassikerPool(pool, state) {
    var modsArr = state.modifiers || [];
    var wantsCaffeine = modsArr.indexOf('med-koffein') >= 0;

    var ratioCompatiblePool = pool;
    if (state.formal === 'energi-under' && shouldEnforceRatioFilter(state)) {
      var requiredRatios = getRequiredRatios(state);
      if (requiredRatios) {
        var filtered = pool.filter(function(p) {
          return p.kulhydratforhold && requiredRatios.indexOf(p.kulhydratforhold) >= 0;
        });
        if (filtered.length >= 2) ratioCompatiblePool = filtered;
      }
    }

    var klassikerPool = ratioCompatiblePool;
    var FAST_MAD_FORMATS = { 'chew': true, 'bar': true, 'waffle': true, 'solid': true };
    if (modsArr.indexOf('fast-mad') < 0) {
      var nonFastMadPool = klassikerPool.filter(function(p) {
        return FAST_MAD_FORMATS[getProductFormat(p)] !== true;
      });
      if (nonFastMadPool.length > 0) klassikerPool = nonFastMadPool;
    }
    if (!wantsCaffeine) {
      var nonCaffeinePool = klassikerPool.filter(function(p) {
        return p.koffein !== 'Med koffein';
      });
      if (nonCaffeinePool.length > 0) klassikerPool = nonCaffeinePool;
    }

    var paired = klassikerPool.map(function(p) {
      return { p: p, score: scoreProduct(p, state) };
    });
    paired.sort(function(a, b) { return b.score - a.score; });

    return {
      ratioCompatiblePool: ratioCompatiblePool,
      sorted: paired.map(function(x) { return x.p; }),
      scores: paired.map(function(x) { return x.score; })
    };
  }

  // FASE 5.2.0: De N bedste match til resultatsiden. Nr. 1 er ALTID
  // sessionens Klassiker (samme rotation/session-cache som
  // selectCurated), så 'Bedste match' ikke hopper mellem re-renders.
  // Nr. 2–3 er de næstbedste efter score, dedupet på navn og handle.
  function selectTopMatches(products, groups, state, n) {
    if (!state) state = {};
    n = n || 3;
    if (state.formal === 'sportstilskud' && state.profile === 'multi') return [];
    var pool = resolveCuratedPool(products, groups, state);
    if (pool.length === 0) return [];
    var ranked = rankKlassikerPool(pool, state);
    if (ranked.sorted.length === 0) return [];

    var out = [];
    var seen = {};
    var klassiker = pickKlassikerFromTopPool(ranked.sorted, ranked.scores, state);
    if (klassiker) {
      out.push(klassiker);
      seen[klassiker.handle] = true;
      seen[klassiker.name] = true;
    }
    for (var i = 0; i < ranked.sorted.length && out.length < n; i++) {
      var p = ranked.sorted[i];
      if (seen[p.handle] || seen[p.name]) continue;
      seen[p.handle] = true;
      seen[p.name] = true;
      out.push(p);
    }
    return out;
  }

  function selectCurated(products, groups, state) {
    if (!state) state = {};
    if (!groups) groups = {};

    var pool = resolveCuratedPool(products, groups, state);
    if (pool.length === 0) return { klassiker: null, specialist: null, variation: null };

    // MULTI-SELECT SPORTSTILSKUD
    if (state.formal === 'sportstilskud' && state.profile === 'multi') {
      var modsSel = state.modifiers || [];
      var multiCards = [];
      var usedHandlesM = {};
      var usedNamesM = {};

      for (var mi = 0; mi < modsSel.length && multiCards.length < 3; mi++) {
        var modKey = modsSel[mi];
        var formalTag = SUPPLEMENT_CATEGORY_FORMAL[modKey];
        var label = SUPPLEMENT_CATEGORY_LABELS[modKey];
        if (!formalTag || !label) continue;

        var priorityKeywords = HANDLE_PRIORITY[modKey] || [];

        var matchesThisCategory = (function(currentModKey, currentFormalTag) {
          return function(prod) {
            if (prod.formal && prod.formal.indexOf(currentFormalTag) >= 0) return true;
            var hLowInner = (prod.handle || '').toLowerCase();
            if (currentModKey === 'performance') {
              if (hLowInner.indexOf('creatine') >= 0 || hLowInner.indexOf('kreatin') >= 0) return true;
              if (prod.brand === 'Beet It Sport') return true;
            }
            if (currentModKey === 'søvn-restitution') {
              if (hLowInner.indexOf('magnesium') >= 0) return true;
            }
            return false;
          };
        })(modKey, formalTag);

        var bestMatch = null;
        for (var pi = 0; pi < pool.length; pi++) {
          var pCand = pool[pi];
          if (usedHandlesM[pCand.handle]) continue;
          if (usedNamesM[pCand.name]) continue;
          if (!matchesThisCategory(pCand)) continue;

          var hLow = (pCand.handle || '').toLowerCase();
          var hasPriority = priorityKeywords.some(function(kw) {
            return hLow.indexOf(kw) >= 0;
          });
          if (hasPriority) {
            bestMatch = pCand;
            break;
          }
        }

        if (!bestMatch) {
          for (var pj = 0; pj < pool.length; pj++) {
            var p2 = pool[pj];
            if (usedHandlesM[p2.handle]) continue;
            if (usedNamesM[p2.name]) continue;
            if (matchesThisCategory(p2)) {
              bestMatch = p2;
              break;
            }
          }
        }

        if (bestMatch) {
          multiCards.push({ product: bestMatch, label: label });
          usedHandlesM[bestMatch.handle] = true;
          usedNamesM[bestMatch.name] = true;
        }
      }

      return { multiCards: multiCards };
    }

    // KOFFEIN-DISQUALIFIER, CARB-TARGET-FILTER og negativ-defaults
    // lever nu i rankKlassikerPool (FASE 5.2.0) — delt med
    // selectTopMatches, så resultatsidens tre kort og kittet aldrig
    // kan rangere forskelligt.
    var ranked = rankKlassikerPool(pool, state);
    var ratioCompatiblePool = ranked.ratioCompatiblePool;

    var klassiker = pickKlassikerFromTopPool(ranked.sorted, ranked.scores, state);

    if (!klassiker) {
      return { klassiker: null, specialist: null, variation: null };
    }

    // SPECIALISTEN
    var specialist = null;
    for (var si = 0; si < ratioCompatiblePool.length; si++) {
      var sp = ratioCompatiblePool[si];
      if (sp.handle === klassiker.handle || sp.name === klassiker.name) continue;
      if (!specialist) specialist = sp;

      if (state.formal === 'energi-under') {
        if ((sp.kulhydrat === 'Ekstra stor (60 g+)' || sp.kulhydrat === 'Stor (41–59 g)')
            && (klassiker.kulhydrat !== 'Ekstra stor (60 g+)' && klassiker.kulhydrat !== 'Stor (41–59 g)')) {
          specialist = sp; break;
        }
        if (sp.kulhydratforhold === 'Performance: 2:1' && klassiker.kulhydratforhold !== 'Performance: 2:1') {
          specialist = sp; break;
        }
      }
      if (state.formal === 'hydrering') {
        if (sp.elektrolyt === 'Komplet elektrolyt (Alle mineraler)' && klassiker.elektrolyt !== 'Komplet elektrolyt (Alle mineraler)') {
          specialist = sp; break;
        }
        if (sp.natrium === '200 mg+' && klassiker.natrium !== '200 mg+') {
          specialist = sp; break;
        }
      }
      if (state.formal === 'restitution') {
        if (sp.protein_type && sp.protein_type !== klassiker.protein_type && sp.protein_type === 'Hydrolyseret (avanceret)') {
          specialist = sp; break;
        }
      }
    }

    // ═══════════════════════════════════════════════════════
    // TAG OGSÅ — supplement-rolle (FASE 2.5.0)
    // ═══════════════════════════════════════════════════════
    // Tag også er KUN aktiv på energi-under — det er supplement-kortet
    // til primær fueling. På hydrering/restitution/sportstilskud
    // returnerer vi null, så UI'et viser kun 2 kort.
    //
    // På energi-under accepterer vi KUN fast føde (bar/chew/waffle/solid)
    // som supplement. Hvis ingen passer, returnerer vi null — bedre at
    // vise 2 gode kort end at fylde med "andet brand med samme format".
    var variation = null;

    if (state.formal === 'energi-under') {
      var SOLID_FORMATS = { 'bar': true, 'chew': true, 'waffle': true, 'solid': true };

      for (var vi = 0; vi < pool.length; vi++) {
        var vp = pool[vi];
        if (vp.handle === klassiker.handle || vp.name === klassiker.name) continue;
        if (specialist && (vp.handle === specialist.handle || vp.name === specialist.name)) continue;

        var fmt = getProductFormat(vp);
        if (SOLID_FORMATS[fmt] === true) {
          variation = vp;
          break;
        }
      }
      // Hvis Bedste match SELV er fast føde (sjælden case — atleten valgte
      // fast-mad-filter), så vi har allerede et fast føde-produkt som primær.
      // I så fald skipper vi Tag også — supplement-rollen er overflødig.
      var klassikerFmt = getProductFormat(klassiker);
      if (SOLID_FORMATS[klassikerFmt] === true) {
        variation = null;
      }
    }
    // Hydrering, restitution, sportstilskud: variation forbliver null.
    // UI'et rendrer 2 kort i stedet for 3.

    return { klassiker: klassiker, specialist: specialist, variation: variation };
  }

  // ══════════════════════════════════════════════════
  //  FASE 2: FINAL2 KLASSIFIKATION
  // ══════════════════════════════════════════════════
  var VARIANT_TO_PURPOSE = {
    'Gels':                'energi-under',
    'Energibar':           'energi-under',
    'Energipulver':        'energi-under',
    'Pulver med energi':   'hybrid',
    'Tabletter':           'hydrering',
    'Recovery':            'restitution',
    'Proteinbar':          'restitution',
    'Protein Pulver':      'restitution',
    'Flydende tilskud':    'sportstilskud',
    'Pulver tilskud':      'sportstilskud',
    'Kapsler & Tabletter': 'sportstilskud',
    'Kapsler':             'sportstilskud'
  };

  function classifyHybridSubcategory(carbPerPortion) {
    if (carbPerPortion == null) return 'træningshydrering';
    if (carbPerPortion < 5)   return 'daglig-hydrering';
    if (carbPerPortion < 25)  return 'træningshydrering';
    return 'energi-hydrering';
  }

  function classifySupplementSubcategory(p) {
    var t = (p.title || '').toLowerCase();
    var h = (p.handle || '').toLowerCase();
    var search = t + ' ' + h;

    if (/regen/i.test(search))                                       return { subCategory: 'sportstilskud',        hasRecoveryTag: true  };
    if (/magnesium|sleep/i.test(search))                             return { subCategory: 'søvn-restitution',     hasRecoveryTag: false };
    if (/triple|joint|motion[\s-]armour|collagen[\s-]repair/i.test(search)) return { subCategory: 'skadesforebyggelse', hasRecoveryTag: false };
    if (/immune|immun|vitamin[\s-]?c|zinc|zink/i.test(search))       return { subCategory: 'immunforsvar',         hasRecoveryTag: false };
    if (/focus|fokus|pre[\s-]?workout|koffein[\s-]kapsler/i.test(search)) return { subCategory: 'mental-fokus',         hasRecoveryTag: false };
    if (/creatine|kreatin/i.test(search))                            return { subCategory: 'performance',          hasRecoveryTag: false };
    if (/nitrate|nitrat|beet/i.test(search))                         return { subCategory: 'performance',          hasRecoveryTag: false };
    if (/nomio/i.test(search))                                       return { subCategory: 'performance',          hasRecoveryTag: false };
    if (/omega|fish[\s-]oil/i.test(search))                          return { subCategory: 'generel-sundhed',      hasRecoveryTag: false };

    return { subCategory: 'sportstilskud', hasRecoveryTag: false };
  }

  function parsePerPortion(rawString) {
    if (!rawString || typeof rawString !== 'string') return null;
    var match = rawString.match(/\/\s*([\d.,]+)\s*(?:g|mg)/i);
    if (match) {
      var n = parseFloat(match[1].replace(',', '.'));
      return isNaN(n) ? null : n;
    }
    var single = rawString.match(/([\d.,]+)\s*(?:g|mg)/i);
    if (single) {
      var n2 = parseFloat(single[1].replace(',', '.'));
      return isNaN(n2) ? null : n2;
    }
    return null;
  }

  function classifySpecialFlags(p, carbPerPortion) {
    var flags = [];

    var koffeinMg = parsePerPortion(p.koffein_mg_raw);
    if (koffeinMg != null && koffeinMg >= 50) flags.push('race-egnet');

    if (carbPerPortion != null && carbPerPortion >= 35) {
      if (flags.indexOf('race-egnet') < 0) flags.push('race-egnet');
    }

    if (carbPerPortion != null) {
      if (carbPerPortion >= 40) flags.push('lang-træning');
      else if (carbPerPortion >= 30 && p.variant_raw === 'Energibar') flags.push('lang-træning');
    }

    var sukkerPerPortion = parsePerPortion(p.sukker_raw);
    if (sukkerPerPortion != null && sukkerPerPortion <= 5) flags.push('lavt-sukker');

    return flags;
  }

  function isMaurtenAddition(p, carbPerPortion) {
    if (p.brand !== 'Maurten') return false;
    var t = (p.title || '').toLowerCase();
    var h = (p.handle || '').toLowerCase();
    return t.indexOf('addition') >= 0 || h.indexOf('addition') >= 0;
  }

  function classifyProduct(p) {
    if (!p) return p;

    var variant = p.variant_raw || null;
    var carbPerPortion = parsePerPortion(p.kulhydrater_raw);

    var autoMainPurpose = variant ? VARIANT_TO_PURPOSE[variant] : null;
    var subCategory = null;

    if (autoMainPurpose === 'hybrid') {
      var hybridSub = classifyHybridSubcategory(carbPerPortion);
      if (hybridSub === 'energi-hydrering') {
        autoMainPurpose = 'energi-under';
        subCategory = 'energi-hydrering';
      } else {
        autoMainPurpose = 'hydrering';
        subCategory = hybridSub;
      }
    }

    var hasRecoveryTag = false;
    if (autoMainPurpose === 'sportstilskud') {
      var supSub = classifySupplementSubcategory(p);
      subCategory = supSub.subCategory;
      hasRecoveryTag = supSub.hasRecoveryTag;
    } else {
      var t = (p.title || '').toLowerCase();
      var h = (p.handle || '').toLowerCase();
      if (/regen/i.test(t + ' ' + h)) hasRecoveryTag = true;
    }

    var manualPurpose = null;
    if (p.formal && p.formal.length > 0) {
      for (var i = 0; i < p.formal.length; i++) {
        var f = p.formal[i];
        if (f === 'Alm. træning' || f === 'Lang træning' || f === 'Tempo' || f === 'Ydelse & Udholdenhed' || f === 'Lavt sukkerindhold') {
          manualPurpose = 'energi-under';
          break;
        }
        if (f && f.indexOf('Hydrering') === 0) {
          manualPurpose = 'hydrering';
          break;
        }
        if (f === 'Efter normal træning' || f === 'Efter hård belastning') {
          manualPurpose = 'restitution';
          break;
        }
        if (['Søvn & Restitution', 'Immunforsvar', 'Led & Skadesforebyggelse', 'Fokus & Mental Skarphed'].indexOf(f) >= 0) {
          manualPurpose = 'sportstilskud';
          break;
        }
      }
    }

    var finalMainPurpose = manualPurpose || autoMainPurpose || null;

    var specialFlags = classifySpecialFlags(p, carbPerPortion);

    p.variant = variant;
    p.mainPurpose = finalMainPurpose;
    p.autoMainPurpose = autoMainPurpose;
    p.manualPurpose = manualPurpose;
    p.subCategory = subCategory;
    p.specialFlags = specialFlags;
    p.hasRecoveryTag = hasRecoveryTag;
    p.isMaurtenAddition = isMaurtenAddition(p, carbPerPortion);
    p.carbPerPortion = carbPerPortion;
    p.sodiumPerPortion = parsePerPortion(p.natrium_raw);
    p.caffeinePerPortion = parsePerPortion(p.koffein_mg_raw);
    p.proteinPerPortion = parsePerPortion(p.protein_raw_g);

    return p;
  }

  function classifyProducts(products) {
    if (!Array.isArray(products)) return products;
    products.forEach(classifyProduct);
    return products;
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.2.2: matchProductsV2 — primær match-funktion
  // ══════════════════════════════════════════════════
  // Hydrerings-grenen bruger nu qualifiesAsHydration som strikt filter.
  // Det udelukker energi-formater og højkulhydrat-pulvere uanset om de
  // har elektrolytter eller "Under træning"-tag.
  //
  // Andre grene (energi-under, restitution, sportstilskud) bruger stadig
  // mainPurpose + filter.formal-fallback.
  function matchProductsV2(products, state) {
    if (!state || !state.formal) return [];
    var mods = state.modifiers || [];
    var wantsKreatin     = mods.indexOf('med-kreatin') >= 0;
    var wantsPerformance = mods.indexOf('performance') >= 0;
    var allowYdelse = (state.formal === 'restitution' && wantsKreatin)
                   || (state.formal === 'sportstilskud' && wantsPerformance);

    var matched = products.filter(function(p) {
      if (state.formal === 'hydrering') {
        // FASE 2.2.2: Strikt hydrerings-filter.
        // qualifiesAsHydration udelukker energi-formater (gel/bar/chew/waffle/solid)
        // og højkulhydrat-pulvere (>=25g per portion). Det er den faglige
        // sandhed: et produkt med 60g carbs er energi, ikke hydrering, selvom
        // det har elektrolytter indbygget.
        if (!qualifiesAsHydration(p)) return false;

        // Yderligere: hvis produktet har hvornar-tag, skal det være
        // brugbart "Under træning" eller mangle hvornar (legacy).
        // Dette filtrerer fx Beet It Sport (Før træning kun) ud af hydrerings-resultatet.
        var hvornar = p.hvornar || [];
        if (hvornar.length > 0 && hvornar.indexOf('Under træning') < 0) {
          return false;
        }

        return true;
      }

      // FASE 2: mainPurpose som primær vej for andre formål
      if (p.mainPurpose === state.formal) {
        if (state.formal === 'restitution' && p.subCategory === 'performance' && wantsKreatin) {
          return true;
        }
        return true;
      }

      // Beet It Regen-undtagelse
      if (state.formal === 'restitution' && p.hasRecoveryTag) return true;
      if (state.formal === 'sportstilskud' && p.hasRecoveryTag) return true;

      // Legacy fallback
      if (!p.mainPurpose && p.formal && p.formal.length > 0) {
        var targetFormaal = FORMAAL_TARGETS[state.formal] || [];
        var effectiveTarget = allowYdelse ? targetFormaal.concat(['Ydelse & Udholdenhed']) : targetFormaal;
        return p.formal.some(function(f) { return effectiveTarget.indexOf(f) >= 0; });
      }

      return false;
    });

    // ─── HARDT FORMAT-FILTER (FASE 2.4.5) ─────────────────────
    // Filtre er bindende — gælder hele resultatsiden, ikke kun Klassikeren.
    // Detekterer 3 scenarier og skriver til lastFilterStatus.
    var modsArr = state.modifiers || [];
    var unfilteredCount = matched.length;
    var appliedFilters = [];
    var incompatibleFilter = null;
    var incompatibleReason = null;

    // Tjek inkompatibilitet FØR filtrering — hvis nogen aktive filtre er
    // logisk inkompatible med formål, returnér tom liste med klar besked.
    // Bemærk: med-kulhydrat er ikke i formatFilters fordi vi ikke har et
    // inkompatibilitets-tjek for det. Det gælder kun hydrerings-flowet
    // og er ikke tilgængeligt for andre formål via wizardet.
    var formatFilters = ['fast-mad', 'tabletter'];
    for (var fi = 0; fi < formatFilters.length; fi++) {
      var fName = formatFilters[fi];
      if (modsArr.indexOf(fName) >= 0) {
        var reason = checkFilterIncompatibility(fName, state.formal);
        if (reason) {
          incompatibleFilter = fName;
          incompatibleReason = reason;
          break;
        }
      }
    }

    if (incompatibleFilter) {
      lastFilterStatus = {
        status: 'INCOMPATIBLE',
        appliedFilters: [incompatibleFilter],
        incompatibleFilter: incompatibleFilter,
        incompatibleReason: incompatibleReason,
        matchedCount: 0,
        unfilteredCount: unfilteredCount
      };
      return [];
    }

    // Anvend hardt format-filter
    var FAST_MAD_FORMATS = { 'chew': true, 'bar': true, 'waffle': true, 'solid': true };
    var TABLET_FORMATS   = { 'kapsel': true };

    if (modsArr.indexOf('fast-mad') >= 0) {
      matched = matched.filter(function(p) {
        return FAST_MAD_FORMATS[getProductFormat(p)] === true;
      });
      appliedFilters.push('fast-mad');
    }

    if (modsArr.indexOf('tabletter') >= 0) {
      matched = matched.filter(function(p) {
        return TABLET_FORMATS[getProductFormat(p)] === true;
      });
      appliedFilters.push('tabletter');
    }

    if (modsArr.indexOf('med-koffein') >= 0) {
      matched = matched.filter(function(p) {
        return p.koffein === 'Med koffein';
      });
      appliedFilters.push('med-koffein');
    }

    // ─── Filter 4: med-kulhydrat (kun hydrering) ──────────────
    // FASE 2.4.6: "Lidt energi i drikken" er bindende — atleten vil have
    // drikke MED kulhydrat, ikke rene elektrolyt-tabletter/kapsler. Filtret
    // bruger det eksisterende metafelt custom.filter_kulhydrat_hydration
    // som du allerede har sat på produkterne. Værdi-sammenligning er case-
    // sensitiv ("Med kulhydrat") matcher præcis metafelt-værdien.
    if (modsArr.indexOf('med-kulhydrat') >= 0) {
      matched = matched.filter(function(p) {
        return p.kulhydrat_hydration === 'Med kulhydrat';
      });
      appliedFilters.push('med-kulhydrat');
    }

    // Bestem status baseret på resultat
    var statusValue;
    if (matched.length === 0 && appliedFilters.length > 0) {
      statusValue = 'EMPTY';
    } else if (matched.length > 0 && matched.length < 3 && appliedFilters.length > 0) {
      statusValue = 'LIMITED';
    } else {
      statusValue = 'OK';
    }

    lastFilterStatus = {
      status: statusValue,
      appliedFilters: appliedFilters,
      incompatibleFilter: null,
      incompatibleReason: null,
      matchedCount: matched.length,
      unfilteredCount: unfilteredCount
    };

    var scored = matched.map(function(p) {
      return { p: p, score: scoreProduct(p, state) };
    });
    scored.sort(function(a, b) { return b.score - a.score; });

    return scored.map(function(s) { return s.p; });
  }


  window.SportEnergyRules = {
    FORMAAL_TARGETS:             FORMAAL_TARGETS,
    SUPPLEMENT_CATEGORY_LABELS:  SUPPLEMENT_CATEGORY_LABELS,
    SUPPLEMENT_CATEGORY_FORMAL:  SUPPLEMENT_CATEGORY_FORMAL,
    HANDLE_PRIORITY:             HANDLE_PRIORITY,
    VARIANT_TO_PURPOSE:          VARIANT_TO_PURPOSE,
    HYDRATION_CARB_THRESHOLD:    HYDRATION_CARB_THRESHOLD,

    getCarbTarget:        getCarbTarget,
    getQuantityEstimate:  getQuantityEstimate,
    getKitQuantity:       getKitQuantity,
    bucketFromMinutes:    bucketFromMinutes,
    getHydrationTarget:   getHydrationTarget,
    getFuelingPlan:       getFuelingPlan,
    getRequiredRatios:    getRequiredRatios,
    shouldEnforceRatioFilter: shouldEnforceRatioFilter,
    getAthleteLevel:      getAthleteLevel,
    getProductFormat:     getProductFormat,
    qualifiesAsHydration: qualifiesAsHydration,
    scoreProduct:         scoreProduct,
    groupByHvornar:       groupByHvornar,
    selectCurated:        selectCurated,
    selectTopMatches:     selectTopMatches,

    classifyProduct:    classifyProduct,
    classifyProducts:   classifyProducts,

    matchProducts:      matchProductsV2,
    matchProductsLegacy: matchProducts,
    getFilterStatus:    getFilterStatus
  };

  // FASE 2.7.0: Load-log gated bag SEG_DEBUG (jf. Fase 2.6.0).
  if (window.SEG_DEBUG) console.log('[Sport Energy Rules / Fase 2.7.0] Modul loadet. ' +
    Object.keys(window.SportEnergyRules).length + ' eksporterede funktioner og konstanter. ' +
    'Sport+intensitet differentiering aktiv: 3 sportsgrene giver reelt forskellige anbefalinger. ' +
    'Profil-konsolidering: 2 mave-options (solid/følsom), 2 svedtab-options (normal/højt). ' +
    'Strikt hydrerings-filter (carb < ' + HYDRATION_CARB_THRESHOLD + 'g, ingen energi-formater).');
})();